import { Component, OnInit } from '@angular/core';
import { ThemeService } from 'src/app/services/base/theme.service';

@Component({
  selector: 'app-ribbon-delete',
  templateUrl: './ribbon-delete.component.html',
  styleUrls: ['./ribbon-delete.component.scss']
})
export class RibbonDeleteComponent implements OnInit {

  constructor(public theme:ThemeService) { }

  ngOnInit(): void {
  }

}
